import React from "react";
import { useNavigate } from "react-router-dom";

const InvoiceTable = ({ invoices }) => {
    const navigate = useNavigate();
    return (
        <div className="overflow-x-auto">
            <table className="min-w-full bg-white border border-gray-200 rounded-lg shadow-lg">
                <thead>
                    <tr className="bg-gray-200 text-black">
                        <th className="py-1.5 px-4 text-left text-[16px] whitespace-nowrap font-medium text-black ">#</th>
                        <th className="py-1.5 px-4 text-left text-[16px] whitespace-nowrap font-medium text-black ">Invoice ID</th>
                        <th className="py-1.5 px-4 text-left text-[16px] whitespace-nowrap font-medium text-black ">Customer Name</th>
                        <th className="py-1.5 px-4 text-left text-[16px] whitespace-nowrap font-medium text-black ">Payment Due Date</th>
                        <th className="py-1.5 px-4 text-left text-[16px] whitespace-nowrap font-medium text-black ">Total Amount</th>
                        <th className="py-1.5 px-4 text-left text-[16px] whitespace-nowrap font-medium text-black ">Paid Amount</th>
                        <th className="py-1.5 px-4 text-left text-[16px] whitespace-nowrap font-medium text-black ">Status</th>
                    </tr>
                </thead>
                <tbody>
                    {invoices?.map((invoice, index) => (
                        <tr key={invoice.id} onClick={() => navigate(`/dashboard/invoices/${invoice.id}`)} className="cursor-pointer border-t border-gray-200 text-gray-600">
                            <td className="py-2 text-black px-4 text-[13px] whitespace-nowrap">{index + 1}</td>
                            <td className="py-2 text-black px-4 text-[13px] whitespace-nowrap">MVL{invoice?.id}M</td>
                            <td className="py-2 text-black px-4 text-[13px] whitespace-nowrap lowercase">
                                {invoice?.customer?.first_name?.split(' ').slice(0, 2).join(' ') || 'N/A'}
                            </td>
                            <td className="py-2 text-black px-4 text-[13px] whitespace-nowrap">{new Date(invoice?.payment_due_date).toLocaleDateString()}</td>
                            <td className="py-2 text-black px-4 text-[13px] whitespace-nowrap">Kes. {parseFloat(invoice?.total_amount).toFixed(2)}</td>
                            <td className="py-2 text-black px-4 text-[13px] whitespace-nowrap">Kes. {parseFloat(invoice?.paid_amount || 0).toFixed(2)}</td>
                            <td className="py-2 text-black px-4 text-[13px] whitespace-nowrap">
                                <span
                                    className={`px-3 py-1 rounded-full text-[11px] text-black ${invoice.payment_status === "pending"
                                        ? "bg-yellow-400"
                                        : invoice.payment_status === "partially_paid"
                                            ? "bg-orange-500"
                                            : "bg-green-500"
                                        }`}
                                >
                                    {invoice.payment_status.replace("_", " ").toUpperCase()}
                                </span>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default InvoiceTable;
